import { BadgeVariations } from '@synqo/frontend-component-library';
import { EnumStagingStatus } from './Generated';

export function getEnumStagingStatusLabel(value: EnumStagingStatus | undefined) {
    switch (value) {
        case EnumStagingStatus.New:
            return 'Neu';
        case EnumStagingStatus.Seen:
            return 'Gesehen';
        case EnumStagingStatus.Imported:
            return 'Importiert';
        case EnumStagingStatus.Rejected:
            return 'Abgelehnt';
        default:
            return '';
    }
}

export function getBadgeVariantByStagingStatus(value: EnumStagingStatus | undefined): BadgeVariations {
    switch (value) {
        case EnumStagingStatus.New:
            return 'accent';
        case EnumStagingStatus.Seen:
            return 'default';
        case EnumStagingStatus.Imported:
            return 'success';
        case EnumStagingStatus.Rejected:
            return 'danger';
        default:
            return 'default';
    }
}
